export default __webpack_public_path__ + "static/media/gallery_04.33104f1b.jpg";